// src/services/CategoryModel.js

export const CATEGORY_REGISTRY = {
  tech: {
    id: "tech",
    label: "Tech & Startups",
    icon: "💻",
    color: "bg-blue-500",
  },
  social: {
    id: "social",
    label: "Social & Drinks",
    icon: "🍻",
    color: "bg-orange-500",
  },
  sports: {
    id: "sports",
    label: "Sports & Fitness",
    icon: "⚽",
    color: "bg-green-500",
  },
  arts: {
    id: "arts",
    label: "Arts & Culture",
    icon: "🎨",
    color: "bg-purple-500",
  },
  outdoor: {
    id: "outdoor",
    label: "Outdoor & Hiking",
    icon: "🥾",
    color: "bg-emerald-700",
  },
  food: {
    id: "food",
    label: "Food & Coffee",
    icon: "☕",
    color: "bg-amber-600",
  },
  gaming: {
    id: "gaming",
    label: "Gaming & Geek",
    icon: "🎮",
    color: "bg-pink-600",
  },
  learning: {
    id: "learning",
    label: "Learning",
    icon: "📚",
    color: "bg-teal-500",
  },
};

export const CATEGORY_LIST = Object.values(CATEGORY_REGISTRY);

export const getCategoryById = (id) =>
  CATEGORY_REGISTRY[id] || {
    id: "other",
    label: "Other",
    icon: "✨",
    color: "bg-gray-500",
  };
